const COLOR = '#d6e016';

const logTurboEvents = () => {
  const turboEvents = [
    // Navigation Events (Page Visits)
    'turbo:before-visit', // Before Turbo starts navigating (can cancel or modify visit).
    'turbo:visit', // After navigation begins, but before fetching the new page.
    'turbo:before-cache', // Just before the current page is cached for back/forward nav.
    'turbo:before-render', // Before rendering the new page (after fetch).
    'turbo:render', // After the new page is rendered into the DOM.
    'turbo:load', // After page is fully loaded (like DOMContentLoaded, but Turbo-aware).

    // Network & Fetch Events
    'turbo:before-fetch-request', // Before any fetch request (visit, form, frame, stream).
    'turbo:before-fetch-response', // Before the response is processed by Turbo.
    'turbo:fetch-request-error', // If a fetch request fails due to a network/server error.

    // Form Submission Events
    'turbo:submit-start', // When a form submission begins (after validation).
    'turbo:submit-end', // When the form submission ends (success or error).

    // Frame Events
    'turbo:frame-missing', // When a frame navigates to a URL that doesn't match any frame.
    'turbo:frame-fetch-request', // Before a Turbo Frame fetch begins (custom or experimental).
    'turbo:frame-load', // After a Turbo Frame loads remote content successfully.
    'turbo:frame-render', // After a Turbo Frame renders new content.

    // Stream Events
    'turbo:before-stream-render', // Before a `<turbo-stream>` is rendered (can cancel).
    'turbo:before-stream-element-append', // Before appending a new element.
    'turbo:before-stream-element-prepend', // Before prepending an element.
    'turbo:before-stream-element-remove', // Before removing an element from the DOM.
    'turbo:before-stream-element-replace', // Before replacing an existing element.
    'turbo:before-stream-element-update', // Before updating innerHTML of a target.
  ];

  turboEvents.forEach((eventType) => {
    document.addEventListener(eventType, (event) => {
      console.groupCollapsed(
        `%c@${eventType}`,
        `color: ${COLOR}; font-weight: bold;`
      );

      console.log('action:', event.target?.action);
      console.log('target:', event.target?.target);
      console.log('method:', event.target?.method);

      console.groupEnd();
    });
  });
};

module.exports = {
  logTurboEvents,
};
